import { render, staticRenderFns } from "./LateralMenuBar.vue?vue&type=template&id=4c7929ba&scoped=true"
import script from "./LateralMenuBar.vue?vue&type=script&lang=js"
export * from "./LateralMenuBar.vue?vue&type=script&lang=js"
import style0 from "./LateralMenuBar.vue?vue&type=style&index=0&id=4c7929ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7929ba",
  null
  
)

export default component.exports